// Punjab-only city list per spec (alphabetical). Some entries (Chandigarh, Mohali) are kept
// even though Chandigarh is a Union Territory — included verbatim as requested.
export const indianCitiesData = [
  {
    city: 'Amritsar', state: 'Punjab',
    areas: ['Golden Temple Area', 'Mall Road', 'Ranjit Avenue', 'Lawrence Road', 'GT Road', 'Majitha Road', 'Chheharta', 'Batala Road', 'Circular Road', 'City Center']
  },
  {
    city: 'Anandpur Sahib', state: 'Punjab',
    areas: ['Naina Devi Road', 'Kiratpur Road', 'Bus Stand Area', 'Old Town', 'Takhta Sahib', 'Charan Ganga', 'Mohalla Bazaar', 'Anandpur Fort Road']
  },
  {
    city: 'Balachaur', state: 'Punjab',
    areas: ['GT Road', 'Garhshankar Road', 'Mahilpur Road', 'Old Bus Stand', 'Civil Lines', 'New Mandi', 'Saroya Road']
  },
  {
    city: 'Banga Nawan Shahr', state: 'Punjab',
    areas: ['GT Road', 'Civil Lines', 'Banga Bazaar', 'Nawanshahr Road', 'Phillaur Road', 'Old Town', 'Mohalla Mehtaban']
  },
  {
    city: 'Barnala', state: 'Punjab',
    areas: ['Sadar Bazaar', 'Mall Road', 'Civil Lines', 'GT Road', 'Bathinda Road', 'Sangrur Road', 'Handiaya Bazaar', 'Model Town']
  },
  {
    city: 'Bathinda', state: 'Punjab',
    areas: ['Mall Road', 'Dhobi Bazaar', 'Goniana Road', 'Faridkot Road', 'Thermal Colony', 'Model Town', 'Rose Garden Area', 'Cantt Area', 'Rail Coach Factory', 'AIIMS Bathinda']
  },
  {
    city: 'Chandigarh', state: 'Punjab',
    areas: ['Sector 17', 'Sector 35', 'Sector 22', 'Sector 26', 'Sector 43', 'Sukhna Lake Area', 'Industrial Area', 'Sector 9', 'Sector 11', 'Sector 34']
  },
  {
    city: 'Firozpur', state: 'Punjab',
    areas: ['Cantt Area', 'Civil Lines', 'GT Road', 'Mall Road', 'Old City', 'Bus Stand Area', 'Ferozeshah Road', 'Hussainiwala Road', 'Mamdot Road']
  },
  {
    city: 'Hoshiarpur', state: 'Punjab',
    areas: ['Mall Road', 'Sutehri Road', 'Bus Stand Area', 'Civil Lines', 'Model Town', 'Jalandhar Road', 'Una Road', 'Dasuya Road', 'Garhshankar Road']
  },
  {
    city: 'Jalandhar', state: 'Punjab',
    areas: ['Model Town', 'Civil Lines', 'GT Road', 'Nakodar Road', 'Kapurthala Road', 'Mithapur', 'Jyoti Nagar', 'Ladowali Road', 'Central Town', 'Cantt Area', 'BMC Chowk', 'Maqsudan', 'Adampur', 'PAP Chowk']
  },
  {
    city: 'Kapurthala', state: 'Punjab',
    areas: ['Jagatjit Palace Road', 'Sultanpur Road', 'Civil Lines', 'Jalandhar Road', 'Mall Road', 'Sheikhpura Road', 'Phagwara Road', 'Begowal', 'Sultanpur Lodhi', 'Subhanpur']
  },
  {
    city: 'Kartarpur', state: 'Punjab',
    areas: ['GT Road', 'Bus Stand Area', 'Gurdwara Road', 'Old City', 'Jalandhar Road', 'Sultanpur Lodhi Road']
  },
  {
    city: 'Kharar', state: 'Punjab',
    areas: ['Sector 125', 'Sector 126', 'NH-21', 'Landran Road', 'Sunny Enclave', 'Desu Majra', 'Kurali Road', 'Old Town', 'Mohali Road']
  },
  {
    city: 'Khanna', state: 'Punjab',
    areas: ['GT Road', 'Grain Market', 'Civil Lines', 'Mandi Gobindgarh Road', 'Samrala Road', 'Old City', 'Model Town', 'Ludhiana Road', 'Industrial Area', 'Doraha Road']
  },
  {
    city: 'Mohali', state: 'Punjab',
    areas: ['Phase 1', 'Phase 3B2', 'Phase 5', 'Phase 7', 'Phase 8', 'Phase 9', 'Phase 10', 'Phase 11', 'Airport Road', 'IT Park']
  },
  {
    city: 'Nakodar', state: 'Punjab',
    areas: ['GT Road', 'Phillaur Road', 'Malsian Road', 'Shahkot Road', 'Jandiala Road', 'Old Bus Stand', 'Civil Lines', 'New Mandi', 'Mohalla Bawewala', 'Rail Bazaar']
  },
  {
    city: 'Phagwara', state: 'Punjab',
    areas: ['GT Road', 'Hargobind Nagar', 'Civil Lines', 'Sugar Mill Area', 'Banga Road', 'Mehli Gate', 'Sarai Sahib', 'Model Town', 'Kapurthala Road', 'LPU Area']
  },
  {
    city: 'Ramamandi', state: 'Punjab',
    areas: ['Main Bazaar', 'Jalandhar Road', 'Cantt Road', 'Mithapur Road', 'Old Village', 'New Colony']
  },
  {
    city: 'Rupnagar', state: 'Punjab',
    areas: ['Sector 12', 'Main Bazaar', 'GT Road', 'NIT Road', 'Chandigarh Road', 'Anandpur Sahib Road', 'Civil Lines', 'Old City']
  },
  {
    city: 'Sangrur', state: 'Punjab',
    areas: ['Patiala Gate', 'Sunami Gate', 'Dhuri Road', 'Civil Lines', 'Mall Road', 'Banasar Bagh', 'Barnala Road', 'Sangrur Bypass']
  },
  {
    city: 'Zirakpur', state: 'Punjab',
    areas: ['VIP Road', 'Patiala Highway', 'Ambala Highway', 'Dhakoli', 'Baltana', 'Peer Muchhalla', 'Lohgarh Road', 'Sector 20 Panchkula border']
  },
];

export const getAllCities = () => indianCitiesData.map(item => item.city);

/**
 * Returns array of { state, cities: [alphabetical city names] }.
 */
export const getCitiesGroupedByState = () => {
  const groups = {};
  for (const item of indianCitiesData) {
    if (!groups[item.state]) groups[item.state] = [];
    groups[item.state].push(item.city);
  }
  return Object.keys(groups)
    .sort((a, b) => a.localeCompare(b))
    .map(state => ({ state, cities: groups[state].sort((a, b) => a.localeCompare(b)) }));
};

/**
 * Returns array of { state, areas: [{ city, area }] }. Cities sorted alphabetically;
 * within each city, areas grouped under city name; final list sorted by area name.
 */
export const getAreasGroupedByState = () => {
  const groups = {};
  for (const item of indianCitiesData) {
    if (!groups[item.state]) groups[item.state] = [];
    for (const area of item.areas) {
      groups[item.state].push({ city: item.city, area });
    }
  }
  return Object.keys(groups)
    .sort((a, b) => a.localeCompare(b))
    .map(state => ({
      state,
      areas: groups[state].sort((a, b) => a.area.localeCompare(b.area)),
    }));
};

export const getAreasByCity = (city) => {
  const cityData = indianCitiesData.find(item => item.city === city);
  return cityData ? cityData.areas : [];
};

export const getAllAreas = () => {
  return indianCitiesData.flatMap(item =>
    item.areas.map(area => ({ city: item.city, state: item.state, area }))
  );
};

export const getCityState = (city) => {
  const cityData = indianCitiesData.find(item => item.city === city);
  return cityData ? cityData.state : '';
};
